import { z } from 'zod';

export const NameBlockSchema = z.string().trim();
export type NameBlock = z.infer<typeof NameBlockSchema>;
